import React from 'react';
import {
    CheckCircle2,
    AlertTriangle,
    RefreshCcw
} from 'lucide-react';
import './ActivityFeed.css';
import type { AnalyticsRealTimeActivity } from '../../services/api';

interface ActivityFeedProps {
    data?: AnalyticsRealTimeActivity[];
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ data = [] }) => {
    return (
        <div className="activity-feed-container">
            <div className="section-header">
                <h3 className="section-title-small">Real-Time Activity</h3>
                <button className="view-all-btn">View all</button>
            </div>
            <div className="activity-list">
                {data.map((item, index) => {
                    const Icon = item.type === 'success' ? CheckCircle2 :
                        item.type === 'warning' ? AlertTriangle :
                            item.type === 'error' ? AlertTriangle : RefreshCcw;

                    const iconColor = item.type === 'success' ? '#10b981' :
                        item.type === 'warning' ? '#f59e0b' :
                            item.type === 'error' ? '#ef4444' : '#3b82f6';
                    return (
                        <div key={index} className="activity-item">
                            <div className="activity-icon-box" style={{ backgroundColor: `${iconColor}10`, color: iconColor }}>
                                <Icon size={18} />
                            </div>
                            <div className="activity-content">
                                <div className="activity-header">
                                    <span className="activity-title">{item.title}</span>
                                    <span className="activity-time">{item.time}</span>
                                </div>
                                <p className="activity-desc">{item.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ActivityFeed;
